/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface HighlightOptionSchema {
  id: string;
  name: string;
  description: string;
  category: string;
}
